export const tableInitialState = {
  items: [],
  loading: false,
  loaded: false,
  page: 1,
  pageSize: 10,
  totalCount: 0,
  sortBy: [],
  filters: {},
};

export const tableAction = (actionTypes, state, action) => {
  switch (action.type) {
    case actionTypes.FulfilledTable: {
      return {
        ...state,
        loading: false,
        loaded: true,
        items: action.items,
        totalCount: action.totalCount,
      };
    }

    case actionTypes.ResetFilters: {
      return {
        ...state,
        ...action.data,
        page: 1,
        filters: tableInitialState.filters,
        searchQuery: '',
      };
    }

    case actionTypes.RequestData: {
      return {
        ...state,
        ...action.data,
        loading: true,
      };
    }

    case actionTypes.AddItem: {
      return {
        ...state,
        items: [...state.items, action.item],
      };
    }

    case actionTypes.SearchTable: {
      return {
        ...state,
        page: 1,
        searchQuery: action.searchQuery,
      };
    }

    case actionTypes.ChangePage: {
      return {
        ...state,
        page: action.page,
      };
    }

    case actionTypes.SetPageSize: {
      return {
        ...state,
        pageSize: action.pageSize,
      };
    }

    case actionTypes.SortTable: {
      return {
        ...state,
        sortBy: action.sortBy,
      };
    }

    case actionTypes.ApplyFilter: {
      return {
        ...state,
        page: 1,
        filters: {
          ...state.filters,
          [action.key]: action.value,
        },
      };
    }

    case actionTypes.RemoveFilter: {
      const filters = { ...state.filters };
      delete filters[action.key];

      return {
        ...state,
        page: 1,
        filters,
      };
    }

    default:
      return state;
  }
};

export const tableActions = actionTypes => ({
  applyFilter: (key, value) => ({ type: actionTypes.ApplyFilter, key, value }),
  removeFilter: key => ({ type: actionTypes.RemoveFilter, key }),
  resetFilters: () => ({ type: actionTypes.ResetFilters }),
  setPageSize: pageSize => ({ type: actionTypes.SetPageSize, pageSize }),
  sortTable: sortBy => ({ type: actionTypes.SortTable, sortBy }),
  changePage: page => ({ type: actionTypes.ChangePage, page }),
  search: searchQuery => ({
    type: actionTypes.SearchTable,
    searchQuery,
  }),
  addItem: item => ({ type: actionTypes.AddItem, item }),
  removeItem: item => ({ type: actionTypes.RemoveItem, item }),
  requestData: data => ({ type: actionTypes.RequestData, data: data || {} }),
  fulfilled: (items, totalCount) => ({
    type: actionTypes.FulfilledTable,
    items,
    totalCount,
  }),
});
